<button class="exit-button" [class.mobile]="isMobile()" (click)="onExit()">
  <i nz-icon [nzType]="'icons:exit'" class="svg-icon"></i>
</button>

<div class="content" [class.mobile]="isMobile()">
  <h4>{{ i18n.langString("where_is_the_sensor") }}</h4>

  <div
    class="input-area sensor-map-dropdown"
    [class.searchFilled]="searchString() && searchString() !== ''"
  >
    <input
      #searchInput
      nz-input
      [nzAutocomplete]="auto"
      [ngModel]="searchString()"
      (ngModelChange)="onSearchChange($event)"
      (focus)="onInputFocus($event)"
      (blur)="onInputBlur($event)"
      placeholder="{{ i18n.langString('street_or_building') }}"
      class="regular"
      (input)="onTextInput($event)"
    />
    <button class="search-btn" aria-label="search">
      <i
        nz-icon
        nzType="icons:search"
        class="svg-icon search-icon noMarginRight multicolorIcon"
        [class.fillwhite]="searchString() && searchString() !== ''"
      ></i>
    </button>

    <nz-autocomplete #auto (selectionChange)="onSearchSelect($event.nzValue)">
      <!-- Autocomplete results -->
      @if (searchResults() && searchResults().length > 0) {
        @for (res of searchResults(); track res.fulltext) {
          <nz-auto-option
            [nzValue]="res.value"
            [nzLabel]="res.fulltext"
            class="sensor-map-dropdown"
          >
            <div class="label regular">
              <span class="search-term">{{ res.searchTerm }}</span
              >{{ res.label }}
            </div>
            <div class="description detail">{{ res.description }}</div>
          </nz-auto-option>
        }
      }

      <!-- "Set location on map" option -->
      <nz-auto-option
        [nzValue]="''"
        [nzLabel]="''"
        class="set-location-option body-bold"
      >
        <div>
          <i
            nz-icon
            [nzType]="'icons:location'"
            class="svg-icon big-icon fillblackcoral"
          ></i>
          <span>{{ i18n.langString("set_location_on_map") }}</span>
        </div>
      </nz-auto-option>
    </nz-autocomplete>
  </div>

  <div class="map">
    <app-map
      [class.desktop]="true"
      [sensors]="sensors()"
      [showSensors]="showSensors()"
      [satelliteView]="satelliteView()"
      [center]="StartLocation()"
      [position]="sensorPosition()"
      [userLocation]="userLocation()"
      [showPosition]="showSensorPosition()"
      (positionChanged)="onPositionChanged($event)"
    ></app-map>

    <div class="map-bottom-buttons">
      <!-- Toggle satellite vs map view -->
      @switch (satelliteView()) {
        @case (true) {
          <app-nav-button
            (clickEvent)="satelliteView.set(false)"
            [darksecondary]="true"
            [svgIcon]="'icons:map'"
            class="additionalMapBtns btn-not-wide"
            [bodyBold]="true"
            [wide]="false"
            [smol]="true"
          >
            {{ i18n.langString("map_view") }}
          </app-nav-button>
        }
        @case (false) {
          <app-nav-button
            (clickEvent)="satelliteView.set(true)"
            [darksecondary]="true"
            [svgIcon]="'icons:satellite'"
            class="additionalMapBtns btn-not-wide"
            [bodyBold]="true"
            [wide]="false"
            [smol]="true"
          >
            {{ i18n.langString("satellite_view") }}
          </app-nav-button>
        }
      }

      <!-- Show sensors toggle -->
      <app-nav-button
        [darksecondary]="true"
        class="additionalMapBtns showSensorBtn btn-not-wide"
        [bodyBold]="true"
        [wide]="false"
        [smol]="true"
      >
        {{ i18n.langString("show_sensors") }}
        <nz-switch
          [ngModel]="showSensors()"
          (ngModelChange)="showSensors.set($event)"
        ></nz-switch>
      </app-nav-button>
    </div>
  </div>
</div>
